import { render } from "./MapBoxComponent.vue?vue&type=template&id=08611cde&scoped=true"
import script from "./MapBoxComponent.vue?vue&type=script&lang=js"
export * from "./MapBoxComponent.vue?vue&type=script&lang=js"

import "./MapBoxComponent.vue?vue&type=style&index=0&id=08611cde&scoped=true&lang=scss"

import exportComponent from "/home/forge/olyo.io/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08611cde"]])

export default __exports__